var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dh"}},[_c('button',{attrs:{"id":"geek"}},[_c('img',{attrs:{"id":"GEEK","src":"http://img.nt-geek.club/GK.png"}})]),_vm._v(" "),_c('button',{attrs:{"id":"sayings"}},[_vm._v("Keep Curiosity"),_c('br'),_vm._v("The Power Of Change")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1477f1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dhl.vue
// module id = null
// module chunks = 